/**
 * 横軸の固定列の幅
 */
export const LEFT_FIXED_COLUMN_WIDTH = {
  STATUS: 160,
  BUNDLE_LABEL: 140,
  ORDER_NO: 190,
  SHIPPING_DATE: 100,
  DELIVERY_DATE: 100
} as const satisfies Record<string, number>

/**
 * 横軸の固定列の合計
 * Table の scroll.x に設定する必要がある
 */
export const LEFT_FIXED_WIDTH =
  LEFT_FIXED_COLUMN_WIDTH.STATUS +
  LEFT_FIXED_COLUMN_WIDTH.BUNDLE_LABEL +
  LEFT_FIXED_COLUMN_WIDTH.ORDER_NO +
  LEFT_FIXED_COLUMN_WIDTH.SHIPPING_DATE +
  LEFT_FIXED_COLUMN_WIDTH.DELIVERY_DATE
